import { render } from "./DeviceDetailsStep.vue?vue&type=template&id=6bc0105c"
import script from "./DeviceDetailsStep.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsStep.vue?vue&type=script&lang=js"

import "./DeviceDetailsStep.vue?vue&type=style&index=0&id=6bc0105c&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__